import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {SearchFacetValue} from "../../../api/models/search-facet-value";
import {Observable, Subscription} from "rxjs";

@Component({
  selector: 'app-search-primary-navigation-item',
  templateUrl: './search-primary-navigation-item.component.html',
  styleUrls: ['./search-primary-navigation-item.component.scss']
})
export class SearchPrimaryNavigationItemComponent implements OnInit, OnDestroy {
  @Input()
  facetItem!: SearchFacetValue;
  @Input()
  isHovered!: Observable<boolean>;

  eventsSubscription!: Subscription;
  parentStyle: string = "";
  style: string = "";

  constructor() { }

  ngOnInit(): void {
    this.subscribeMouseEvent();
  }
  ngOnDestroy() {
    this.eventsSubscription.unsubscribe();
  }
  subscribeMouseEvent() {
    this.eventsSubscription = this.isHovered.subscribe((data) => {
      if(data) {
        this.onHoverFromParent();
      } else {
        this.offHoverFromParent();
      }
    })
  }
  mouseEnter(facet: SearchFacetValue) {
    this.style = "hovered-item"
  }
  mouseLeave(facet: SearchFacetValue) {
    this.style = "";
  }
  onHoverFromParent() {
    this.parentStyle = "hovered-list";
  }
  offHoverFromParent() {
    this.parentStyle = "";

  }
}
